import React from "react";
import Header from "./Header";
import { useForm, ValidationError } from "@formspree/react";

export default function ContactPage() {
  const [state, handleSubmit] = useForm("mvgvbobj"); // <-- your Formspree form ID

  return (
    <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column text-center">
      <main role="main" className="inner cover">
        <Header />

        <h1 className="cover-heading">Contact Me</h1>

        <p className="lead">
          I’d love to hear from you! Whether you want to chat about technology,
          art, travel, or potential collaborations — feel free to reach out.
        </p>

        <div className="contact-info">
          <p className="lead">
            Connect with me on:
            <br />
            <a
              href="https://www.linkedin.com/in/adi-zingman"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>{" "}
            |{" "}
            <a
              href="https://github.com/azingzap"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </a>
          </p>
        </div>

        {state.succeeded ? (
          <p className="lead" style={{ marginTop: "2rem" }}>
            Thank you for your message! I’ll get back to you soon.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="contact-form">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              className="contact-input"
            />

            <input
              id="email"
              type="email"
              name="email"
              placeholder="Your Email"
              required
              className="contact-input"
            />
            <ValidationError prefix="Email" field="email" errors={state.errors} />

            <textarea
              id="message"
              name="message"
              placeholder="Your Message"
              rows="4"
              required
              className="contact-textarea"
            ></textarea>
            <ValidationError
              prefix="Message"
              field="message"
              errors={state.errors}
            />

            <button type="submit" className="btn btn-lg" disabled={state.submitting}>
              {state.submitting ? "Sending..." : "Send Message"}
            </button>
          </form>
        )}
      </main>

      <footer className="mastfoot mt-auto">
        <div className="inner"></div>
      </footer>
    </div>
  );
}